import {
    RaikoBaseCardContainer,
    RaikoMagazineThumbnailUpload,
    RaikoSectionContainer, showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {OccasionalService} from "../../../serverService/occasional/OccasionalService";
import {useParams} from "react-router-dom";

export default function OccasionalBannerDetailsThumbnail({bannerId}) {



    const service = new OccasionalService()

    const [thumbnailFile, setThumbnailFile] = useState()
    const [thumbnailImage, setThumbnailImage] = useState()

    const [thumbnailLoading, setThumbnailLoading] = useState(false);
    const [actionButtonLoading, setActionButtonLoading] = useState(false);

    useEffect(() => {
        if (typeof service !== "undefined") {
            getThumbnail()
        }
    }, [bannerId]);


    function getThumbnail() {
        setThumbnailLoading(true)
        service.getBannerThumbnailById(bannerId)
            .then(
                response => {
                    setThumbnailImage(response.downloadUrl)
                }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setThumbnailLoading(false)
        })

    }

    function handleChooseImage(file, preview) {
        setThumbnailImage(preview)
        setThumbnailFile(file)
    }

    function handleUpdateBanner() {
        if (thumbnailFile) {
            setActionButtonLoading(true)
            service.updateThumbnail(bannerId,thumbnailFile)
                .then(response=>{
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }).catch(reason => {
                    showServerErrorMessage(reason)
            }).finally(_=>{
                setActionButtonLoading(false)
            })
        } else {
            showWarningMessage("لطفا ابتدا تصویر مورد نظر را انتخاب نمایید.")
        }
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"تصویر شاخص"}
                subTitle={"تصویر شاخص نمایش داده شده برای کاربران"}
                hasActionButton
                actionButtonOnclick={handleUpdateBanner}
                actionButtonLoadingState={actionButtonLoading}
            >
                <RaikoMagazineThumbnailUpload
                    ASPECT_RATIO={16/9}
                    avatarFile={thumbnailImage}
                    updateAvatar={handleChooseImage}
                    loading={thumbnailLoading}
                />
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}